module.exports = __webpack_public_path__ + "static/media/login_background_small.69d0fa16.jpg";